import React, { Suspense } from 'react';
import { IStatisticsGrid } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const DriverStatisticsWrapper = React.lazy(() => import('./driver-statistics'));
export interface IDynamicDriverStatisticsWrapper extends IComponentModel<IStatisticsGrid> {
  live?: boolean;
  model: any;
}

const DynamicDriverStatistics = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicDriverStatisticsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <DriverStatisticsWrapper
      live={live}
      initialModel={validateModel(model) as IStatisticsGrid}
      query={validateModel(query)}
    />
  </Suspense>
);

DynamicDriverStatistics.defaultProps = {
  live: false,
};

export default DynamicDriverStatistics;
